export const DUCK_URL = './models/Duck/glTF/Duck.gltf';
export const HELMET_URL = './models/FlightHelmet/glTF/FlightHelmet.gltf';
export const FOX_URL = './models/Fox/glTF/Fox.gltf';
export const HAMBURGER_URL = 'https://i0hci4avyoqkwwp1.public.blob.vercel-storage.com/hamburger.glb';
export const DAMAGED_HELMET_URL = './models/DamagedHelmet/glTF/DamagedHelmet.gltf';